import { Reveal } from "@/components/site/Motion";
import { ContactButton } from "@/components/site/ContactButton";
import { Petal } from "@/components/site/Petal";
import { STAGES } from "@/lib/content";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import { CoachingScope } from "@/components/site/CoachingScope";

export const JourneyInvitation = () => (
  <section className="px-5 pb-20 pt-8 sm:px-8 md:pb-28 md:pt-12 lg:px-12" data-testid="journey-closing">
    <Reveal className="relative mx-auto max-w-6xl overflow-hidden rounded-[2rem] bg-[#221e1b]">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_0%_100%,rgba(168,121,42,0.25),transparent_65%)]"
      />
      <div className="relative grid items-center gap-10 p-7 sm:p-12 lg:grid-cols-[1.2fr_1fr] lg:gap-16 lg:p-16">
        <div>
          <p className="text-center text-[0.8125rem] font-semibold uppercase tracking-[0.18em] text-[#e9cc94] sm:text-left">Your next step</p>
          <h2 className="font-display mt-5 text-center text-[2.5rem] font-medium leading-[1.08] tracking-tight text-[#faf5ee] sm:text-left sm:text-6xl">
            Start with<br />
            <em className="text-[#e9cc94]">a conversation.</em>
          </h2>
          <p className="mt-6 max-w-md text-[1.0625rem] leading-[1.75] text-[#d9cfc2] sm:text-lg">
            Private 1:1 coaching is available now. Connect with Sheetal to explore your goals and
            daily habits, or ask about the upcoming 21-day journey.
          </p>
          <div className="mt-8 flex items-center justify-center gap-4 sm:justify-start" aria-hidden="true">
            {STAGES.map((stage) => <Petal key={stage.n} color={stage.color} size={24} />)}
          </div>
          <WhatsAppButton testId="journey-closing-whatsapp-btn" variant="light" className="mt-8">Inquire About 1:1 Coaching</WhatsAppButton>
          <CoachingScope light />
        </div>
        <div className="rounded-[1.5rem] bg-[#faf5ee] p-6 sm:p-9">
          <p className="eyebrow text-center sm:text-left">Joining the journey</p>
          <h3 className="font-display mt-4 text-center text-4xl font-medium leading-tight text-[#221e1b] sm:text-left">
            When can you begin?
          </h3>
          <p className="mt-4 text-[1.0625rem] leading-[1.75] text-[#5d544c]">
            The 21-day program is coming soon. Get in touch with us, and we&apos;ll get back to you with the next available opportunity to join.
          </p>
          <ContactButton testId="journey-closing-contact-btn" size="large" className="mt-7 w-full justify-center" />
        </div>
      </div>
    </Reveal>
  </section>
);
